import about01 from '../assets/about01.png';
import about02 from '../assets/about02.png';
import about03 from '../assets/about03.png';
import about04 from '../assets/about04.png';
import alstroemeria from '../assets/Alstroemeria-psittacina.jpg';
import aniseSage from '../assets/anise-sage.jpg';
import api from '../assets/api.png';
import aquilegaCultorum from '../assets/aquilega-cultorum.jpg';
import beachRose from '../assets/beach-rose.jpg';
import beardedIris from '../assets/beach-rose.jpg';
import bgIMG from '../assets/bgIMG.png';
import bgWhite from '../assets/bgWhite.png';
import bridge from '../assets/overgrown-bridge.jpg';
import calibrachoa from '../assets/calibrachoa.jpg';
import cpp from '../assets/cpp.png';
import crapeMyrtle from '../assets/crape_myrtle.jpg';
import crepeMyrtle from '../assets/crepe_myrtle.jpg';
import css from '../assets/css.png';
import email from '../assets/email.png';
import figma from '../assets/figma.png';
import flutter from '../assets/flutter.png';
import git from '../assets/git.png';
import graphql from '../assets/graphql.png';
import greenery from '../assets/greenery.jpg';
import html from '../assets/html.png';
import hypericum from '../assets/hypericum.jpg';
import indianLantana from '../assets/west-indian-lantana.jpg';
import javascript from '../assets/javascript.png';
import lambsEar from '../assets/lambs-ear.jpg';
import lantana from '../assets/lantana.jpg';
import lilacTree from '../assets/lilac-tree.jpg';
import linkedIn from '../assets/linkedin-logo.png';
import logo from '../assets/BM-logo-noback.png';
import marvelPeru from '../assets/marvel-of-peru.jpg';
import mu5 from '../assets/mu5.png';
import node from '../assets/node.png';
import orangeDayLily from '../assets/orange-day-lily.jpg';
import overGrownWall from '../assets/Overgrown-wall.jpg';
import pacMan from '../assets/PacMan-Game.png';
import peanutCactus from '../assets/peanut-cactus.jpg';
import pinkRose from '../assets/pink_rose.jpg';
import pinkRose2 from '../assets/pink-rose2.jpg';
import ponderosaLemon from '../assets/ponderosa-lemon.jpg';
import portfolio from '../assets/Portfolio.png';
import profile from '../assets/bethany.jpg';
import python from '../assets/python.png';
import react from '../assets/react.png';
import redRose from '../assets/red-rose.jpg';
import redux from '../assets/redux.png';
import sacredDatura from '../assets/sacred-datura.jpg';
import sass from '../assets/sass.png';
import stBrunoLily from '../assets/st-bruno-lily.jpeg';
import tailwind from '../assets/tailwindcss.png';
import telephoneBooth from '../assets/telephone-booth.jpg';
import tigerLily from '../assets/tiger-lily.jpg';
import typescript from '../assets/typescript.png';
import vue from '../assets/vue.png';
import yellowDayLily from '../assets/yellow-daylily.jpg';

const images = {
  api,
  bgIMG,
  bgWhite,
  cpp,
  css,
  email,
  figma,
  flutter,
  git,
  graphql,
  html,
  javascript,
  linkedIn,
  mu5,
  node,
  python,
  react,
  redux,
  sass,
  typescript,
  vue,
  about01,
  about02,
  about03,
  about04,
  profile,
  logo,
  calibrachoa,
  crapeMyrtle,
  crepeMyrtle,
  hypericum,
  lantana,
  pinkRose,
  stBrunoLily,
  aniseSage,
  aquilegaCultorum,
  beachRose,
  beardedIris,
  lambsEar,
  lilacTree,
  marvelPeru,
  orangeDayLily,
  bridge,
  peanutCactus,
  pinkRose2,
  ponderosaLemon,
  redRose,
  sacredDatura,
  telephoneBooth,
  tigerLily,
  indianLantana,
  yellowDayLily,
  greenery,
  overGrownWall,
  alstroemeria,
  pacMan,
  portfolio,
  tailwind,
};

export default images;
